import Home from '../api/home';
import * as mutation from '../mutations/home';

const state = {
  notifications_updated_cnt: 0,
  today: {
    // carousel: [],
    tour: [], // 둘러보기
    recommend: [], // 시작하기
    hotStories: [],
    languageStudyStore: [],
    community: [],
    community_max_page: 2,
    store: [],
    curations: [],
    curations_max_page: 2,
  },
  subscription: {
    channels_max_page: 2,
    channels: [],
    latest_updated_cnt: 0,
    posts_max_page: 2,
    posts: [],
  },
  subject: {
    // title: '',
    channels: [],
    posts: [],
  },
  notifications_max_page: 2,
  notifications: {
    today: [],
    last: [],
  },
};

const getters = {
  subscriptionUpdatedCnt: state => state.subscription.latest_updated_cnt,
  notificationsUpdatedCnt: state => state.notifications_updated_cnt,
  // carousel: state => state.today.carousel,
  tour: state => state.today.tour,
  recommend: state => state.today.recommend,
  hotStories: state => state.today.hotStories,
  languageStudyStore: state => state.today.languageStudyStore,
  community: state => state.today.community,
  communityMaxPage: state => state.today.community_max_page,
  store: state => state.today.store,
  curations: state => state.today.curations,
  channels: state => state.subscription.channels,
  posts: state => state.subscription.posts,
  // subjectTitle: state => state.subject.title,
  subjectChannels: state => state.subject.channels,
  subjectPosts: state => state.subject.posts,
  notifications: state => state.notifications,
};

const actions = {
  selectHome ({ commit }, second) {
    // if (!state.today.carousel.length) {
      return Home.getHome(second).then(response => {
        commit(mutation.SELECT_HOME, response);
      }).catch(err => {
        console.error(err);
      })
    // }
  },
  selectCommunity ({ commit }, { page, second, keyword, menuIdx, nationIdx }) {
    if (page <= state.today.community_max_page) {
      return Home.getCommunity(second, page, keyword, menuIdx, nationIdx).then(response => {
        commit(mutation.SELECT_COMMUNITY, response);
      }).catch(err => {
        console.error(err);
      });
    }
  },
  selectStore ({ commit }, { second, page }) {
    return Home.getStore(second, page).then(response => {
      commit(mutation.SELECT_STORE, response);
    }).catch(err => {
      console.error(err);
    });
  },
  selectCurations ({ commit, state }, { second, page }) { // 투데이
    if (!state.today.curations.length) {
      return Home.getCuration(second, page).then(response => {
        commit(mutation.SELECT_CURATIONS, response);
      }).catch(err => {
        console.error(err);
      });
    }
  },
  selectSubject ({ commit }, { subjectIdx, sectionIdx }) { // 투데이 -> 주제 더보기
    return Home.getSubjectChannel(subjectIdx, sectionIdx).then(response => {
      commit(mutation.SELECT_SUBJECT, response.data);
    }).catch(err => {
      console.error(err);
    });
  },
  selectSubscribedChannels ({ commit }, { second, page }) { // 구독 채널
    if (page <= state.subscription.channels_max_page) {
      return Home.getSubscribeChannel(second, page).then(response => {
        commit(mutation.SELECT_SUBSCRIBED_CHANNELS, response);
      }).catch(err => {
        console.error(err);
      });
    }
  },
  selectSubscribedPosts ({ commit }, { second, page }) { // 구독 채널의 포스트
    if (page <= state.subscription.posts_max_page) {
      return Home.getSubscribePost(second, page).then(response => {
        commit(mutation.SELECT_SUBSCRIBED_POSTS, response);
      }).catch(err => {
        console.error(err);
      });
    }
  },
  selectNotificationsUpdatedCnt ({ commit }) {
    return Home.getPushCount().then(response => {
      commit(mutation.SELECT_NOTIFICATIONS_UPDATE_CNT, response.data);
    }).catch(err => {
      console.error(err);
    });
  },
  selectNotifications ({ commit }, { second, page }) {
    if (page <= state.notifications_max_page) {
      return Home.getPush(second, page).then(response => {
        commit(mutation.SELECT_NOTIFICATIONS, response);
      }).catch(err => {
        console.error(err);
      });
    }
  },
};

const mutations = {
  [mutation.SELECT_HOME] (state, response) {
    // state.today.carousel.push(...response.data.ad);
    state.today.tour = response.data.tour;
    state.today.recommend = response.data.recommend_store;
    state.today.hotStories = response.data.hot_store;
    state.today.languageStudyStore = response.data.language_study_store;
  },
  [mutation.SELECT_COMMUNITY] (state, response) {
    state.today.community_max_page = response.max_page;
    response.req_page === 1 ? state.today.community = response.data : state.today.community.push(...response.data);
  },
  [mutation.SELECT_STORE] (state, response) {
    state.today.store = response.data; // 한번만 함
  },
  [mutation.SELECT_CURATIONS] (state, response) {
    state.today.curations = response.data;
  },
  [mutation.SELECT_SUBJECT] (state, subject) {
    state.subject = subject;
  },
  [mutation.SORT_SUBJECT_POSTS] (state, filter) { // 투데이 -> 더보기에서 카드 정렬(최신순 / 인기순)
    if (filter === 'latest') { // 최신순
      state.subject.posts.sort((a, b) => {
        return a.created_at > b.created_at ? -1 : a.created_at < b.created_at ? 1 : 0;
      });
    } else { // 인기순
      state.subject.posts.sort((a, b) => {
        return a.like_cnt > b.like_cnt ? -1 : a.like_cnt < b.like_cnt ? 1 : 0;
      });
    }
  },
  [mutation.SELECT_SUBSCRIBED_CHANNELS] (state, response) {
    state.subscription.channels_max_page = response.max_page;
    response.req_page === 1 ? state.subscription.channels = response.data : state.subscription.channels.push(...response.data);
  },
  [mutation.SELECT_SUBSCRIBED_POSTS] (state, response) {
    state.subscription.posts_max_page = response.max_page;
    state.subscription.latest_updated_cnt = response.data.latest_update_cnt;
    response.req_page === 1 ? state.subscription.posts = response.data.posts : state.subscription.posts.push(...response.data.posts);
  },
  [mutation.TOGGLE_SUBSCRIPTION] (state, { idx, flag }) { // 투데이 -> 더보기에서 채널 구독시 뮤테이션
    if (state.subject.channels.length) {
      let target = state.subject.channels.find(el => {
        return el.idx === idx;
      });
      if (typeof target !== 'undefined') {
        target.subscribes = flag;
        flag ? target.subscribe_cnt++ : target.subscribe_cnt--;
      }
    }
  },
  [mutation.TOGGLE_LIKE] (state, { idx, flag, location, subjectIdx }) { // 홈 탭에서 뮤테이션
    if (typeof subjectIdx === 'number') {
      let target = state[location].curations[subjectIdx].contents.find(el => {
        return el.type === 'feed' && el.idx === idx;
      });
      if (typeof target !== 'undefined' && typeof flag === 'boolean') {
        target.likes = flag;
        flag ? target.like_cnt++ : target.like_cnt--;
      }
    } else { // 리뉴얼: 구독 탭 사라짐 -> 홈 > 커뮤니티 탭에서 뮤테이션
      // if (state[location].posts.length) {
      //   let target = state[location].posts.find(el => {
      //     return el.idx === idx;
      //   });
      //   if (typeof target !== 'undefined' && typeof flag === 'boolean') {
      //     target.likes = flag;
      //     flag ? target.like_cnt++ : target.like_cnt--;
      //   }
      // }
      if (state.today.community.length) {
        let target = state.today.community.find(el => {
          return el.idx === idx;
        });
        if (typeof target !== 'undefined' && typeof flag === 'boolean') {
          target.likes = flag;
          flag ? target.like_cnt++ : target.like_cnt--;
        }
      }
    }
  },
  [mutation.TOGGLE_BOOKMARK] (state, { idx, flag, location }) { // 홈 탭에서 뮤테이션
    if (typeof location !== 'undefined') {
      if (state[location].posts.length) {
        let target = state[location].posts.find(el => {
          return el.idx === idx;
        });
        if (typeof target !== 'undefined') {
          target.bookmarks = flag;
          flag ? target.bookmark_cnt++ : target.bookmark_cnt--;
        }
      }
    } else {
      if (state.today.community.length) {
        let target = state.today.community.find(el => {
          return el.idx === idx;
        });
        if (typeof target !== 'undefined') {
          target.bookmarks = flag;
          flag ? target.bookmark_cnt++ : target.bookmark_cnt--;
        }
      }
    }
  },
  [mutation.SELECT_NOTIFICATIONS_UPDATE_CNT] (state, count) {
    state.notifications_updated_cnt = count;
  },
  [mutation.SELECT_NOTIFICATIONS] (state, response) {
    state.notifications_max_page = response.max_page;
    if (response.req_page === 1) {
      state.notifications.today = response.data.today;
      state.notifications.last = response.data.last;
    } else {
      state.notifications.today.push(...response.data.today);
      state.notifications.last.push(...response.data.last);
    }
  },
  [mutation.TOGGLE_STORE_BOOKMARK] (state, { idx, flag }) { // 홈 상품 북마크
    if (state.today.hotStories.length) {
      let target = state.today.hotStories.find(el => {
        return el.idx === idx;
      });
      if (typeof target !== 'undefined') {
        target.bookmarks = flag;
        flag ? target.bookmark_cnt++ : target.bookmark_cnt--;
      }
    }
    if (state.today.store.length) {
      let target = state.today.store.find(el => {
        return el.idx === idx;
      });
      if (typeof target !== 'undefined') {
        target.bookmarks = flag;
        flag ? target.bookmark_cnt++ : target.bookmark_cnt--;
      }
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
